import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addEmployement,
  deleteEmployement,
  getEmployement,
  updateEmployement,
} from "store/services/dataManagement/employment";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

//Get All Employment
export const GetAllEmploymentAction = createAsyncThunk(
  "employment/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getEmployement(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Delete Employment
export const DeleteEmploymentAction = createAsyncThunk(
  "employment/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;
      const res = await deleteEmployement(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        const responce = await getEmployement(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Update Employment
export const UpdateEmploymentAction = createAsyncThunk(
  "employment/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    let { onSucess, onError, ...rest } = payload;
    try {
      const res = await updateEmployement(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSucess) onSucess();

        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Add Employment
export const AddEmploymentAction = createAsyncThunk(
  "employment/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSucess, onError, filter, ...rest } = payload;
      const res = await addEmployement(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSucess) onSucess();

        dispatch(closeAdminModal());
        const response = await getEmployement(filter);
        if (response.status === 1) {
          return fulfillWithValue(response);
        }
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
